export default __webpack_public_path__ + "static/media/blockchain-background.6fa5fdf1.jpeg";